import React, { useState } from 'react';
import PropTypes from 'prop-types';
import windowService from '../services/windowService';
import apiClient from '../services/apiClient';
import { ListItemFlexRow } from '../components/ListItemFlexRow';

const ReportRow = ({ report, tasklistInstanceId, tasklistName = '', assigneeName = '' }) => {
  const getHeadingByReportType = reportType =>
    ['CPIA', 'CPCA'].includes(reportType) ? 'Assessor Cumulative' : 'Candidate Cumulative Report';

  const getViewTypeByReportType = reportType => (['CPIA', 'CPCA'].includes(reportType) ? 'Assessor' : 'Candidate');

  const encodeFileName = reportType =>
    encodeURIComponent(`${assigneeName} ${tasklistName}_${getViewTypeByReportType(reportType)}`).replace(/ /gi, '_');

  const encodeFilePath = reportUrl => encodeURIComponent(reportUrl);

  const constructDownloadUrl = (fileName, filePath) =>
    `${apiClient.getConfig().baseURL}/v1/files?fileName=${fileName}&filePath=${filePath}`;

  const downloadFile = report =>
    windowService.openUrl(constructDownloadUrl(encodeFileName(report.id), encodeFilePath(report.reportId)));

  return (
    <ListItemFlexRow onClick={() => downloadFile(report)}>
      <h4>{getHeadingByReportType(report.id)}</h4>
    </ListItemFlexRow>
  );
};

ReportRow.propTypes = {
  report: PropTypes.object,
  tasklistInstanceId: PropTypes.string,
  tasklistName: PropTypes.string,
  assigneeName: PropTypes.string,
};

export default ReportRow;
